module.exports = __webpack_public_path__ + "img/news05.f244d92c.png";